module.exports = __webpack_public_path__ + "static/media/onboarding-4.faa1aec2.png";